module.exports = __webpack_public_path__ + "img/arcos-c-img-3.2a17fd74.jpg";